import dateTimeHelper from "../Helpers/datetimeHelper";
import stringHelper from "../Helpers/stringHelper";
import React from "react";
import RedirectLinkComponent from "../Elements/RedirectLinkComponent";
import FigmaBadge from "../Elements/FigmaBadge";

export default class AllAssignmentItem {
  constructor(item) {
    if (item === undefined) {
      this.AsId = "";
      this.AsSassieAsgnId = "";
      this.CuName = "";
      this.AsFee = "";
      this.OpportunityCurrencySymbol = "";
      this.AsFeeAddit = "";
      this.AsReimbursement = "";
      this.ReimbursementCurrencySymbol = "";
      this.AsTravel = "";
      this.AsGaming = "";
      this.AsMisc = "";
      this.AsLdvname = "";
      this.AsFieldworkFee = "";
      this.AsEvname = "";
      this.LgsDesc = "";
      this.AsEvaluatorCompletedDate = "";
      this.CuCountry = "";
      this.AsFeeWithSymbol = "";
      this.AsEvaluatorCompletedDateFormatted = "";
      this.AsFeeAdditWithSymbol = "";
      this.AsReimbursementWithSymbol = "";
      this.AsTravelWithSymbol = "";
      this.AsGamingWithSymbol = "";
      this.AsMiscWithSymbol = "";
      this.AsFieldworkFeeWithSymbol = "";
      this.AsInid = "";
      this.AsUninvoiceable = "";
      this.AsCfname = "";
      this.AsCfid = "";
    } else {
      this.AsId = item.asId;
      this.AsSassieAsgnId = item.asSassieAsgnId;
      this.CuName = item.cuName;
      this.AsFee = item.asFee;
      this.OpportunityCurrencySymbol = item.opportunityCurrencySymbol;
      this.AsFeeAddit = item.asFeeAddit;
      this.AsReimbursement = item.asReimbursement;
      this.ReimbursementCurrencySymbol = item.reimbursementCurrencySymbol;
      this.AsTravel = item.asTravel;
      this.AsGaming = item.asGaming;
      this.AsMisc = item.asMisc;
      this.AsLdvname = item.asLdvname;
      this.AsFieldworkFee = item.asFieldworkFee;
      this.AsEvname = item.asEvname;
      this.LgsDesc = item.lgsDesc;
      this.AsEvaluatorCompletedDate = item.asEvaluatorCompletedDate;
      this.CuCountry = item.cuCountry;
      this.AsFeeWithSymbol = stringHelper.getValueWithSymbol("", item.opportunityCurrencySymbol, item.asFee);
      this.AsEvaluatorCompletedDateFormatted = dateTimeHelper.toYYYYsMMsDD(item.asEvaluatorCompletedDate, "-");
      this.AsFeeAdditWithSymbol = stringHelper.getValueWithSymbol("", item.reimbursementCurrencySymbol, item.asFeeAddit);
      this.AsReimbursementWithSymbol = stringHelper.getValueWithSymbol("", item.opportunityCurrencySymbol, item.asReimbursement);
      this.AsTravelWithSymbol = stringHelper.getValueWithSymbol("", item.opportunityCurrencySymbol, item.asTravel);
      this.AsGamingWithSymbol = stringHelper.getValueWithSymbol("", item.opportunityCurrencySymbol, item.asGaming);
      this.AsMiscWithSymbol = stringHelper.getValueWithSymbol("", item.opportunityCurrencySymbol, item.asMisc);
      this.AsFieldworkFeeWithSymbol = stringHelper.getValueWithSymbol("", item.opportunityCurrencySymbol, item.asFieldworkFee);
      this.AsInid = item.asInid;
      this.AsUninvoiceable = item.lgsDesc === "Uninvoiceable";
      this.AsCfname = item.asCfname;
      this.AsCfid = item.asCfid;
      this.InCiid = item.inCiid;
    }
  }

  static idFunction(item) {
    return (
      <RedirectLinkComponent
        isFigmaStyle={true}
        path="assignments"
        tooltipText={item.AsSassieAsgnId}
        text={item.AsSassieAsgnId}
        keyValuePairs={[
          { key: "AsBillClient", value: "" },
          { key: "AsPayEvaluator", value: "" },
          { key: "AsSassieAsgnId", value: item.AsSassieAsgnId },
        ]}
      />
    );
  }

  static NameOfTheIdField() {
    return "AsId";
  }
  static nameOfTheItemDetailList(item) {
    return "Ready for Invoicing";
  }

  static MoneyFields = [];

  static Currency() {
    return "";
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return "";
  }

  static DateFields = [];

  static BoolFields = [];

  static FieldsToShowInListTable = [];

  static getIsActiveCellContent(asUninvoiceable) {
    return (
      <div className="pointer">
        <FigmaBadge
          Active={asUninvoiceable}
          ActiveText="Yes"
          InactiveText="No"
          width={50}
        />
      </div>
    );
  }
  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      { label: "Apollo Id", orderById: "AsSassieAsgnId", data: AllAssignmentItem.idFunction },
      { label: "Invoice", orderById: "InCiid", data: "InCiid" },
      {
        label: "Location",
        orderById: "CuName",
        data: "CuName",
        minWidth: 250,
      },
      { label: "FW Office", orderById: "AsLdvname", data: "AsLdvname" },
      { label: "Evaluator", orderById: "AsEvname", data: "AsEvname" },
      { label: "Status", orderById: "LgsDesc", data: "LgsDesc", minWidth: 70 },
      { label: "Completed On", orderById: "AsEvaluatorCompletedDateFormatted", data: "AsEvaluatorCompletedDateFormatted", minWidth: 90 },
      { label: "Country", orderById: "CuCountry", data: "CuCountry", minWidth: 55 },
      { label: "Uninv.", orderById: "AsUninvoiceable", data: (item) => AllAssignmentItem.getIsActiveCellContent(item.AsUninvoiceable), minWidth: 55 },
    ];
  }

  // static getActionsContent(item)
  // {
  // 	return (
  // 		<div>
  // 			<FaIcon
  // 				iconName="fa-solid fa-edit"
  // 				className="pointer link"
  // 				tooltipText="Edit"
  // 				onClick={()=>CaspianXXQueryProcessingHistoryItem.editFunction(item.Id,item)}
  // 			/>
  // 		</div>
  // 	);
  // }

  static editFunction(id, item) {
    //this is just a placeholder
  }
}
